<div class="mx-4 flex gap-4 h-auto flex-col sm:flex-row sm:h-9 sm:items-center">
  <!-- Título: tamaño automático -->
  <!-- <div
    class="pr-3 text-base text-(--comp-tabs-titule) font-semibold text-primary shrink-0 sm:border-r-2"
  >
    {{ titule }}
  </div> -->

  <!-- Tabs con botones de scroll -->
  <div class="flex gap-3">
    @if (showLeftButton || showRightButton) {
      <button
        [disabled]="!showLeftButton"
        matMiniFab
        class="px-2 text-lg"
        (click)="scrollTabs('left')"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    }

    @if (showLeftButton || showRightButton) {
      <button
        [disabled]="!showRightButton"
        matMiniFab
        class="px-2 text-lg"
        (click)="scrollTabs('right')"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>
  <div
    #tabsContainer
    class="flex flex-1 gap-3 overflow-x-auto overflow-hidden!"
    style="scroll-behavior: smooth"
    (scroll)="onTabsScroll()"
  >
    @for (tabAux of tabs; track $index) {
      <div
        class="text-base font-medium px-8 py-1.5 rounded-3xl flex items-center justify-center border-2"
        (click)="indexSelected = $index; onTabChange($index)"
        [ngClass]="{
          'cursor-pointer bg-(--comp-tabs-section-bg-disabled) text-(--comp-tabs-section-disabled)  border-(--comp-tabs-section-border-disabled)':
            indexSelected != $index,
          'bg-(--comp-tabs-section-bg-active) text-(--comp-tabs-section-active) border-(--comp-tabs-section-border-active) ':
            indexSelected == $index,
        }"
      >
        <div>
          {{ tabAux.descripcion }}
        </div>
      </div>
    }
  </div>
</div>
